"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.ButtonsContainer = exports.Question = exports.Header = exports.IconContainer = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRainbowComponents = require("react-rainbow-components");

var Container = _styledComponents["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "sc-1fs5yfa-0"
})(["display:flex;flex-direction:", ";"], function (props) {
  return props.direction;
});

exports.Container = Container;

var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled__IconContainer",
  componentId: "sc-1fs5yfa-1"
})(["margin:1.32rem 0 1rem 1rem;"]);

exports.IconContainer = IconContainer;

var Header = _styledComponents["default"].div.withConfig({
  displayName: "styled__Header",
  componentId: "sc-1fs5yfa-2"
})(["font-size:22px;font-weight:900;font-stretch:normal;font-style:normal;line-height:1.27;letter-spacing:normal;color:", ";padding:2rem 2rem 1rem 1rem;"], function (props) {
  return props.theme.rainbow.palette.text.title;
});

exports.Header = Header;

var Question = _styledComponents["default"].div.withConfig({
  displayName: "styled__Question",
  componentId: "sc-1fs5yfa-3"
})(["font-size:18px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.56;letter-spacing:normal;color:", ";padding:0 2rem 0.5rem 1rem;"], function (props) {
  return props.theme.rainbow.palette.text.main;
});

exports.Question = Question;

var ButtonsContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled__ButtonsContainer",
  componentId: "sc-1fs5yfa-4"
})(["display:flex;justify-content:flex-end;padding:4px 0 0 0;"]);

exports.ButtonsContainer = ButtonsContainer;
var Button = (0, _styledComponents["default"])(_reactRainbowComponents.Button).withConfig({
  displayName: "styled__Button",
  componentId: "sc-1fs5yfa-5"
})(["padding-left:1.5rem;padding-right:1.5rem;margin-left:0.7rem;"]);
exports.Button = Button;